import SpinwheelLanding from '../../../onboarding/components/spinwheel/SpinwheelLanding';

export default function SpinwheelTestScreen() {
    return <SpinwheelLanding />;
}
